import styled, { keyframes } from 'styled-components';

const lineAnimation = keyframes`
  from {width: 0;}
`;
const loadingAnimation = keyframes`
    0% {
        opacity: 0.2;
    }
    60% {
        opacity: 0.9;
    }
    100% {
        opacity: 0.2;
    }
`;

export const StyledLineWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 0.2rem;
`;
export const StyledLineText = styled.div`
  font-size: 0.8rem;
  margin-left: 0.5rem;
`;

export const StyledInnerLineText = styled.span`
  color: #82888a;
  font-size: 1rem;
  margin-left: 0.5rem;
  letter-spacing: 0.2rem;
`;

export const StyledLine = styled.div`
  background-color: ${props => (props.color ? props.color : '#EBEEF5')};
  width: ${props => (props.value ? `${props.value}%` : 0)};
  height: 1.3rem;
  animation: ${lineAnimation} 1s linear;
  border-top-right-radius: 3px;
  border-bottom-right-radius: 3px;
  display: flex;
  align-items: center;
  &.loading {
    animation: ${loadingAnimation} 2s infinite alternate;
  }
`;

export const StyledMultiLinesChart = styled.div`
  width: 35%;
`;
